import React from 'react';

import StickyHeader from 'components/Layouts/Admin/Dashboard/StickyHeader';
import { Collapse, Panel } from 'components/shared/Collapse';
import PageHeader from 'components/shared/PageHeader';
import Text from 'components/shared/Typography/Text';

function Help() {
  return (
    <StickyHeader>
      <PageHeader title="Help" />
      <Collapse>
        <Panel title="Tutorials">
          <Text accent>No Data</Text>
        </Panel>

        <Panel title="Helpful Articles">
          <Text accent>No Data</Text>
        </Panel>

        <Panel title="Questions">
          <Text accent>No Data</Text>
        </Panel>
      </Collapse>
    </StickyHeader>
  );
}

export default Help;
